import 'yup-phone';

import * as yup from 'yup';

const nameMinLen = 2;
const nameMaxLen = 30;
const nameMinError = `Min length is ${nameMinLen}`;
const nameMaxError = `Max length is ${nameMaxLen}`;

export const formValidationSchema = {
  email: yup.string().email('Enter a valid email address').required('Required'),
  phone: yup.string().phone('US', true, 'Invalid number').required('Required'),
  firstName: yup.string().min(nameMinLen, nameMinError).max(nameMaxLen, nameMaxError).required('Required'),
  lastName: yup.string().min(nameMinLen, nameMinError).max(nameMaxLen, nameMaxError).required('Required'),
  password: yup
    .string()
    .min(8, 'Password should be a minimum 8 characters')
    .required('Required')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*1234567890])(?=.{8,})/,
      'Password must contain 1 uppercase letter, 1 lowercase letter, and 1 number or special character',
    ),
  passwordConfirm: yup
    .string()
    .required('Required')
    .oneOf([yup.ref('password'), null], 'Passwords must match'),
  required: yup.string().required('Required'),
  // zipCode: yup.string().matches(/(^\d{5}$)|(^\d{5}-\d{4}$)/, 'Invalid zip code'),
  zipCode: yup.string().required('Required').length(5, 'Invalid code'),
};
